import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Star } from "lucide-react";

export default function ReviewModal({ isOpen, onClose, onSubmit, provider }) {
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [reviewText, setReviewText] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (rating === 0) {
      return;
    }
    onSubmit({ rating, review_text: reviewText });
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl text-text-primary">
            Review {provider?.name}
          </DialogTitle>
          <DialogDescription className="font-body text-text-secondary">
            Share your experience to help others make informed decisions.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-6 mt-4">
          <div>
            <Label className="font-body font-semibold text-text-primary mb-3 block">
              Your Rating *
            </Label>
            <div className="flex gap-2">
              {[1, 2, 3, 4, 5].map((star) => (
                <button
                  key={star}
                  type="button"
                  data-testid={`star-${star}`}
                  onClick={() => setRating(star)}
                  onMouseEnter={() => setHoverRating(star)}
                  onMouseLeave={() => setHoverRating(0)}
                  className="transition-transform hover:scale-110"
                >
                  <Star
                    className={`w-10 h-10 ${
                      star <= (hoverRating || rating)
                        ? "fill-secondary text-secondary"
                        : "text-gray-300"
                    }`}
                  />
                </button>
              ))}
            </div>
          </div>
          <div>
            <Label htmlFor="review_text" className="font-body font-semibold text-text-primary">
              Your Review *
            </Label>
            <Textarea
              id="review_text"
              data-testid="review-text"
              value={reviewText}
              onChange={(e) => setReviewText(e.target.value)}
              required
              className="mt-2 font-body min-h-[120px]"
              placeholder="Tell us about your experience with this provider..."
            />
          </div>
          <div className="flex gap-3 pt-4">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              className="flex-1 h-12 font-body font-semibold"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              data-testid="submit-review"
              disabled={rating === 0 || !reviewText.trim()}
              className="flex-1 h-12 bg-primary text-white hover:bg-[#238C82] font-body font-semibold disabled:opacity-50"
            >
              Submit Review
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
